






import Vue, { PropType } from "vue";
import log from "loglevel";

import {
  PostUpdatepassPaymentInformationEditRequest,
  PostUpdatepassPaymentInformationEditResponse
} from "@/containers/updatepassPaymentInformationNewRegister/api";

export interface UpdatepassPaymentInformationNewRegisterProps {
  returnUrl: string;
  errorUrl: string;
  setupIntentId: string;
  contractNumber: string;
  countryCode: string;
  planPriceId: string;
  price: string;
  currencyCode: string;
  savePaymentInformation: any;
  waitingTime: number;
}

export interface UpdatepassPaymentInformationNewRegisterData {
  isComplete: boolean;
}

export default Vue.extend({
  name: "vc-updatepass-payment-information-new-register",
  props: {
    returnUrl: {
      type: String as PropType<
        UpdatepassPaymentInformationNewRegisterProps["returnUrl"]
      >,
      default: ""
    },
    errorUrl: {
      type: String as PropType<
        UpdatepassPaymentInformationNewRegisterProps["errorUrl"]
      >,
      default: ""
    },
    setupIntentId: {
      type: String as PropType<
        UpdatepassPaymentInformationNewRegisterProps["setupIntentId"]
      >,
      default: ""
    },
    contractNumber: {
      type: String as PropType<
        UpdatepassPaymentInformationNewRegisterProps["contractNumber"]
      >,
      default: ""
    },
    countryCode: {
      type: String as PropType<
        UpdatepassPaymentInformationNewRegisterProps["countryCode"]
      >,
      default: ""
    },
    planPriceId: {
      type: String as PropType<
        UpdatepassPaymentInformationNewRegisterProps["planPriceId"]
      >,
      default: ""
    },
    price: {
      type: String as PropType<
        UpdatepassPaymentInformationNewRegisterProps["price"]
      >,
      default: ""
    },
    currencyCode: {
      type: String as PropType<
        UpdatepassPaymentInformationNewRegisterProps["currencyCode"]
      >,
      default: ""
    },
    waitingTime: {
      type: Number as PropType<
        UpdatepassPaymentInformationNewRegisterProps["waitingTime"]
      >,
      default: 0
    },
    // actionsToProps
    postUpdatepassPaymentInformationEdit: {
      type: Function as PropType<
        UpdatepassPaymentInformationNewRegisterProps["savePaymentInformation"]
      >,
      default: () => {}
    }
  },
  data(): UpdatepassPaymentInformationNewRegisterData {
    return {
      isComplete: false
    };
  },
  mounted() {
    this.executionPostUpdatepassPaymentInformation();
  },
  methods: {
    async executionPostUpdatepassPaymentInformation() {
      const requestData = {
        setupIntentId: this.setupIntentId,
        contractNumber: this.contractNumber,
        countryCode: this.countryCode,
        planPriceId: this.planPriceId,
        price: this.price,
        currencyCode: this.currencyCode
      } as PostUpdatepassPaymentInformationEditRequest;

      try {
        const res: PostUpdatepassPaymentInformationEditResponse = await this.postUpdatepassPaymentInformationEdit(
          requestData
        );
        this.isComplete = true;
        window.location.href =
          res && res.status === "success"
            ? this.returnUrl + "?contractNumber=" + res.contractNumber
            : this.errorUrl +
              "?type=" +
              res.message_type +
              "&errorCode=" +
              res.errorCode;
      } catch (error) {
        log.error(error);
        window.location.href = this.errorUrl + "?type=default_error";
        throw error;
      }
    }
  }
});
